import React, { useEffect, useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import PhotoSwipeGallery from './PhotoSwipeGalleryModule';
import { renderStyledElementStyles } from '../../../../helpers';

const StyledPhotoSwipeGallery = styled(PhotoSwipeGallery)`
  .pswp__button--close {
    ${({ theme }) =>
      renderStyledElementStyles(
        theme,
        theme.module.vStyles.elements?.gallery?.elements?.close,
      )}
    ${({ theme }) => theme.module.dStyles.elements?.gallery?.elements?.close}
  }

  .pswp-thumbnail {
    ${({ theme }) =>
      theme.module.vStyles.elements?.gallery?.elements?.thumbnail}
    ${({ theme }) =>
      theme.module.dStyles.elements?.gallery?.elements?.thumbnail}
  }

  .pswp__top-bar {
    ${({ theme }) => theme.module.vStyles.elements?.gallery?.elements?.topBar}
    ${({ theme }) => theme.module.dStyles.elements?.gallery?.elements?.topBar}
  }
  .pswp__bg {
    ${({ theme }) => theme.module.vStyles.elements?.gallery?.elements?.bg}
    ${({ theme }) => theme.module.dStyles.elements?.gallery?.elements?.bg}
  }
`;

// Photo gallery options object
const photoswipeOptions = {
  index: 0,
  barsSize: { top: 0, bottom: 'auto' },
  bgOpacity: 0.85,
  showHideOpacity: true,
  captionEl: false,
  shareEl: false,
  counterEl: false,
  arrowEl: false,
  fullscreenEl: false,
  zoomEl: false,
  preloaderEl: false,
  closeOnScroll: false,
  history: false,
};

export const PhotoGallery = ({ componentRef, title, imagePath, alt }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [imageWidth, setImageWidth] = useState(null);
  const [imageHeight, setImageHeight] = useState(null);

  // Handle close photo gallery event
  const handleClose = useCallback(() => {
    setIsOpen(false);
  }, [setIsOpen]);

  // Returns gallery image
  const getThumbnailContent = useCallback(
    (item) => {
      return <img src={item.thumbnail} width="100%" height="100%" alt={alt} />;
    },
    [alt],
  );

  // Set height and width of parent container, vendors logic
  const imageLoadComplete = useCallback(() => {
    const zoomableImage = componentRef.current?.querySelector('img');
    if (zoomableImage && !imageWidth && !imageHeight) {
      setImageWidth(zoomableImage.naturalWidth);
      setImageHeight(zoomableImage.naturalHeight);
    }
  }, [componentRef, imageWidth, imageHeight, setImageWidth]);

  const imageProps = [
    {
      src: imagePath,
      thumbnail: imagePath,
      w: imageWidth,
      h: imageHeight,
      title,
    },
  ];

  useEffect(() => {
    imageLoadComplete();
  }, [imageLoadComplete]);

  return (
    <div data-testid="zoomable-image-gallery-wrapper">
      <StyledPhotoSwipeGallery
        isOpen={isOpen}
        items={imageProps}
        onClose={handleClose}
        thumbnailContent={getThumbnailContent}
        options={photoswipeOptions}
        data-testid="zoomable-image-gallery"
      />
    </div>
  );
};

PhotoGallery.propTypes = {
  componentRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.elementType }),
  ]),
  title: PropTypes.string,
  imagePath: PropTypes.string,
};
